const MAX_SET_TIMEOUT_VALUE = 2 ** 31 - 1;
let timeout = null;
export const getToken = async (tokenUpdate, getAppToken) => {
    try {
        const token = (await getAppToken());
        const { access_token: accessToken, expires_in: expiresIn } = token;
        tokenUpdate(null, accessToken);
        const oneMinuteBeforeExpiry = expiresIn * 1000 - 60 * 1000;
        if (timeout) {
            clearTimeout(timeout);
        }
        // Kick off the loop
        timeout = setTimeout(() => {
            getToken(tokenUpdate, getAppToken);
        }, Math.min(oneMinuteBeforeExpiry, MAX_SET_TIMEOUT_VALUE));
        return token;
    }
    catch (e) {
        tokenUpdate(e);
        return Promise.reject(e);
    }
};
//# sourceMappingURL=authentication.js.map